let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g1qy9")).then(() => parcelRequire('jgi8A'));